import { render, staticRenderFns } from "./NetaMultiEventDetailsView.vue?vue&type=template&id=081050ea&scoped=true&"
import script from "./NetaMultiEventDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaMultiEventDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiEventDetailsView.vue?vue&type=style&index=0&id=081050ea&lang=scss&scoped=true&"
import style1 from "./NetaMultiEventDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081050ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081050ea')) {
      api.createRecord('081050ea', component.options)
    } else {
      api.reload('081050ea', component.options)
    }
    module.hot.accept("./NetaMultiEventDetailsView.vue?vue&type=template&id=081050ea&scoped=true&", function () {
      api.rerender('081050ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/NetaMultiEventDetailsView.vue"
export default component.exports